export enum LinkRelValue {
  noopener = "noopener",
  noreferrer = "noreferrer",
  nofollow = "nofollow"
}

export const EXTERNAL_LINK_REL_VALUE = `${LinkRelValue.noopener} ${LinkRelValue.noreferrer}`;
